import React from "react";
import StepItem from "./StepItem";
import { useIsMobile } from "../../hooks/useIsMobile";
import { LineConnectorProps, StepProgressBarProps } from "./types";

const StepProgressBar: React.FC<StepProgressBarProps> = ({
    steps,
    isCurrent,
}) => {
    const isMobile = useIsMobile(900);

    const LineConnector: React.FC<LineConnectorProps> = ({ isCompleted }) => (
        <div
            className={`${isMobile ? "hidden" : "block"} w-full h-0.5 ${
                isCompleted ? "bg-secondary" : "bg-stone-300"
            }`}
        ></div>
    );

    console.log("isCurrent:", isCurrent);

    return (
        <nav
            className={`flex ${
                isMobile ? "justify-between px-2" : "justify-center px-6"
            } items-center py-4 bg-white rounded-lg w-full`}
            aria-label="Progress"
        >
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                    <div className="flex-1">
                        <StepItem
                            label={
                                isCurrent
                                    ? step.isActive && !step.isCompleted
                                        ? step.label
                                        : ""
                                    : step.label
                            }
                            isActive={step.isActive}
                            isCompleted={step.isCompleted}
                            isMobile={isMobile}
                        />
                    </div>
                    {index < steps.length - 1 && (
                        <LineConnector isCompleted={step.isCompleted} />
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default StepProgressBar;
